import { createReducer, on } from "@ngrx/store";
import { initialState } from "./audit-trail.state";
import * as AuditTrailActions from './audit-trail.action';

export const auditTrailReducer = createReducer(
    initialState,
    on(AuditTrailActions.findAuditTrailsSuccess, (state, { auditTrails }) => ({
        ...state,
        auditTrailResult: auditTrails,
        error: null
    })),
    on(AuditTrailActions.findAuditTrailsError, (state, { error }) => ({
        ...state,
        error: error
    }))
);
